__turbopack_context__.v({
  "header": "PageHeader-module-scss-module__PmxHZG__header",
  "pageHeaderWrapper": "PageHeader-module-scss-module__PmxHZG__pageHeaderWrapper",
});
